import React from 'react';
import { BG_FIELD } from './lib/data';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { GmailReviews } from './components/GmailReviews';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { InstagramReviews } from './components/InstagramReviews';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { ContentPreviewCarousel } from './components/ContentPreviewCarousel';
import { Testimonials } from './components/Testimonials';
import { Checkout } from './components/Checkout';
import { Objections } from './components/Objections';
import { Support } from './components/Support';
import { SalesPopup } from './components/SalesPopup';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="relative min-h-full w-full overflow-x-hidden bg-hockey-ink font-sans text-white" data-id="element-0" data-mp="23vkzqt1dsvr1">
      <MetaPixel data-id="element-1" data-mp="3ikh7o8icgqyg" />

      {/* Blurred field/locker-room background */}
      <div className="pointer-events-none fixed inset-0 z-0" aria-hidden="true" data-id="element-2" data-mp="3ii4ro0w5cqo1">
        <img src={BG_FIELD} alt="" className="h-full w-full scale-110 object-cover opacity-40 blur-sm" data-id="element-3" data-mp="3mjq45l4rr2xp" />
        <div className="absolute inset-0 bg-hockey-ink/80" data-id="element-4" data-mp="6hqffdy0fe4" />
      </div>

      {/* Content — mobile-first, centered column */}
      <main className="relative z-10 mx-auto w-full max-w-md overflow-x-hidden" data-id="element-5" data-mp="2zm4vedw4z0yn">
        <Hero data-id="element-6" data-mp="33lwyib2rgewm" />
        <GmailReviews data-id="element-7" data-mp="33nq921ghvj9w" />
        <Problems data-id="element-8" data-mp="33mykhalbelt4" />
        <Modules data-id="element-9" data-mp="33oi1x4ipj2wh" />
        <InstagramReviews data-id="element-10" data-mp="38m1e7yvuh5ls" />
        <Bonuses data-id="element-11" data-mp="38kqb81a841vq" />
        <Comparison data-id="element-12" data-mp="38k6v8q44vnkc" />
        <ContentPreviewCarousel data-id="element-13" data-mp="38nupxslbeg0n" />
        <Testimonials data-id="element-14" data-mp="3dle2mo2d6kqh" />
        <Checkout data-id="element-15" data-mp="3dlw4c07spr5s" />
        <Objections data-id="element-16" data-mp="3dmfn1j59sjkv" />
        <Support data-id="element-17" data-mp="3dii3wxiozs0z" />
      </main>

      <SalesPopup data-id="element-18" data-mp="nw2ci75e7srm" />
      <StickyBar data-id="element-19" data-mp="nuhhyhj2w9tr" />
    </div>;
}